module.exports = __webpack_public_path__ + "static/media/Welcome.9c5b59a9.png";